var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRightDelta = function SvgRightDelta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.982 1.991v16a1 1 0 0 0 1.524.852l13-8a1 1 0 0 0 0-1.703l-13-8a1 1 0 0 0-1.524.851Zm2 1.79 10.091 6.21-10.09 6.21V3.781Z",
    fill: "#fff"
  })));
};
export default SvgRightDelta;